/** @flow */
import { startRequest, finishRequest } from "@store/utils";
import {
  GetReportingFocusListsEmployeeDefaultReports,
  GetReportingFocusListsEmployeeDefaultReportsSuccess,
  GetReportingFocusListsEmployeeDefaultReportsError,
  GetReportingFocusListsEmployeeMyReports,
  GetReportingFocusListsEmployeeMyReportsSuccess,
  GetReportingFocusListsEmployeeMyReportsError,
  GetFocusListsEmployeeReportSchemaSuccess,
  GetFocusListsEmployeeReportSchemaError,
  SetFocusListsEmployeeReportToSave,
  ReSetFocusListsEmployeeReportToSave,
} from "@modules/reporting/constants/actions";
import type { Reports } from "./types";
import { cloneObject } from "@utils/object";

export const initialState = {
  requestsInProgress: 0,
  error: null,
  defaultReports: [],
  myReports: [],
  schema: null,
  reportToSave: null,
};

export const setLoading = (state: Reports) => () => startRequest(state);

export const onGetReportingFocusListsEmployeeDefaultReportsSuccess = (state: Reports) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  defaultReports: payload,
});

const onGetReportingFocusListsEmployeeDefaultReportsError = (state: Reports) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload.error,
});

export const onGetReportingFocusListsEmployeeMyReportsSuccess = (state: Reports) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  myReports: payload,
});

const onGetReportingFocusListsEmployeeMyReportsError = (state: Reports) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload.error,
});

export const onGetFocusListsEmployeeReportSchemaSuccess = (state: Reports) => ({
  payload,
}: Object) => ({
  ...state,
  error: null,
  schema: payload,
});

export const onGetFocusListsEmployeeReportSchemaError = (state: Reports) => ({
  payload,
}: Object) => ({
  ...state,
  error: payload.error,
});

export const onSetFocusListsEmployeeReportToSave = (state: Reports) => ({ payload }: Object) => ({
  ...state,
  reportToSave: payload,
});
export const onReSetFocusListsEmployeeReportToSave = (state: Reports) => () => ({
  ...state,
  reportToSave: null,
});

export default (state: Reports = initialState, action: Object): Reports => {
  const act = {
    [GetReportingFocusListsEmployeeDefaultReports]: setLoading,
    [GetReportingFocusListsEmployeeDefaultReportsSuccess]: onGetReportingFocusListsEmployeeDefaultReportsSuccess,
    [GetReportingFocusListsEmployeeDefaultReportsError]: onGetReportingFocusListsEmployeeDefaultReportsError,
    [GetReportingFocusListsEmployeeMyReports]: setLoading,
    [GetReportingFocusListsEmployeeMyReportsSuccess]: onGetReportingFocusListsEmployeeMyReportsSuccess,
    [GetReportingFocusListsEmployeeMyReportsError]: onGetReportingFocusListsEmployeeMyReportsError,
    [GetFocusListsEmployeeReportSchemaSuccess]: onGetFocusListsEmployeeReportSchemaSuccess,
    [GetFocusListsEmployeeReportSchemaError]: onGetFocusListsEmployeeReportSchemaError,
    [SetFocusListsEmployeeReportToSave]: onSetFocusListsEmployeeReportToSave,
    [ReSetFocusListsEmployeeReportToSave]: onReSetFocusListsEmployeeReportToSave,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
